import React, {useState} from 'react';
import { Link } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { useForm } from "react-hook-form";

import * as Yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";

import { alertActions } from '@/store/actions/alert.actions';
import AlertTypeEnum from '@/utils/constants/AlertTypeEnum';

import AuthPageWrapper from '@/views/elements/AuthPageWrapper/AuthPageWrapper';
import Spinner from '@/views/components/Spinner/Spinner';
import FormInput from '@/views/components/FormInput/FormInput';
import AppAlert from '@/views/components/Alert/AppAlert';

import api from '@/services/api';

import styles from '@/views/pages/ResetPassword/ResetPassword.module.scss';

const ResetPassword = () => {
	const [ loading, setLoading ] = useState(false);
    
	const dict = useSelector(state => state.app.dict);
	const { tResetPasswordPageTitle, tResetPasswordInfo, tLogin, tLoginPlaceholder, tSendBtn, tBackToLogin, tEmailSent, tUnknownError, errors: { tWrongEmailFormat, tFieldRequired } } = dict.resetPassword;
	const dispatch = useDispatch();

	const yupSchema = Yup.object().shape({
		email: Yup.string().email(tWrongEmailFormat).required(tFieldRequired),
	});

	const { handleSubmit, register, formState: { errors, isValid } } = useForm({
		resolver: yupResolver(yupSchema),
		defaultValues: {
			email: '',
		},
		mode: 'onBlur' ,
	});

	const onSubmit = async ({email}) => {
		setLoading(true);		
		try {
			await api.post('/auth/password-forgot', {
				email,
			});
			dispatch(alertActions.setAlert(AlertTypeEnum.SUCCESS.toString(),  tEmailSent));
		} catch (error) {
			dispatch(alertActions.setAlert(AlertTypeEnum.ERROR.toString(), tUnknownError));
		} finally {
			setLoading(false);
		}
	};

	return (
		<AuthPageWrapper pageTitle={ tResetPasswordPageTitle }>
			{
				loading && (
					<Spinner addClass='dictionary__spinner' />
				)
			}
			<section className={ styles['reset-password__form--wrapper'] }>
				<p className={ styles['reset-password__form--info'] }>
					{ tResetPasswordInfo }
				</p>

				<form
					className={ styles['reset-password__form'] }
					onSubmit={ handleSubmit(onSubmit) }
				>

					<FormInput
						{ ...register('email') }
						labelValue={ tLogin }
						id='email'
						inputType='text'
						placeholder={ tLoginPlaceholder }
						error={ errors.email }
					/>

					<button
						className={ `button__blue ${ styles['reset-password__form--submit'] }${!isValid ? ' disabled' : ''}` }
						type='submit'
					>
						{ tSendBtn }
					</button>

					<Link
						className={ styles['reset-password__form--back-btn'] }
						to='/login'
					>
						<div className={ styles['reset-password__form--back-btn-icon'] }>
							<i className='icon-arrow-left-full' />
						</div> { tBackToLogin }
					</Link>
				</form>
				<AppAlert className={ styles['reset-password__alert'] } />
			</section>
		</AuthPageWrapper>
	);
};
export default ResetPassword;